import { t } from "./i18n.js";

export function renderAbout(view: HTMLElement, bot: string): void {
  view.innerHTML = `
    <div class="about">
      <h2>${t("about.title")}</h2>
      <p>${t("about.intro")}</p>
      <ol>
        <li>${t("about.take_turns")}</li>
        <li>${t("about.write")}</li>
        <li>${t("about.publishes")}</li>
        <li>${t("about.read")}</li>
      </ol>
      <p style="color:var(--muted);font-size:.9rem">${t("about.reminders", { bot })}</p>
      <p style="color:var(--muted);font-size:.9rem">${t("about.no_group")}</p>
    </div>`;
}
